import React, { useEffect } from 'react';
import './LegalPage.css';

const LegalPage = () => {
  // Bloquer l'indexation SEO/GEO
  useEffect(() => {
    // Ajouter meta noindex
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(metaRobots);

    // Ajouter meta googlebot spécifique
    const metaGooglebot = document.createElement('meta');
    metaGooglebot.name = 'googlebot';
    metaGooglebot.content = 'noindex, nofollow';
    document.head.appendChild(metaGooglebot);

    return () => {
      document.head.removeChild(metaRobots);
      document.head.removeChild(metaGooglebot);
    };
  }, []);

  // Déterminer le type de page depuis l'URL
  const pathname = window.location.pathname;
  const isTerms = pathname === '/terms';
  const title = isTerms ? "Conditions d'utilisation" : 'Politique de confidentialité';

  const termsContent = (
    <>
      <p className="legal-page-updated">Dernière mise à jour : 4 juin 2025</p>

      {/*
        * Mentions légales — structure à compléter.
        *
        * Les champs entre crochets sont **volontairement visibles** : un trou qu'on voit se
        * comble, un trou masqué se publie. Ils doivent tous disparaître avant mise en ligne.
        *
        * Pré-rempli depuis la configuration Stripe du compte (dénomination, siège, contacts) :
        * ces valeurs sont celles qui figureront sur les factures, elles doivent concorder.
        */}
      <h2>Mentions légales</h2>

      <h3>Éditeur du service</h3>
      <p>
        Le service Kokpit est édité par <strong>ADSPRING</strong>, <mark>[FORME JURIDIQUE : SAS, SARL…]</mark>
        au capital de <mark>[MONTANT]</mark> euros, dont le siège social est situé 6, avenue de la Créativité,
        59650 Villeneuve-d'Ascq, France.
      </p>
      <ul>
        <li>SIREN : <mark>[NUMÉRO À 9 CHIFFRES]</mark></li>
        <li>SIRET (siège) : <mark>[NUMÉRO À 14 CHIFFRES]</mark></li>
        <li>RCS : <mark>[VILLE D'IMMATRICULATION]</mark> <mark>[NUMÉRO]</mark></li>
        <li>Numéro de TVA intracommunautaire : <mark>[FR + CLÉ + SIREN]</mark></li>
        <li>Code APE / NAF : <mark>[CODE]</mark></li>
      </ul>

      <h3>Direction de la publication</h3>
      <p>Directeur de la publication : <mark>[NOM ET PRÉNOM]</mark>, en qualité de <mark>[FONCTION]</mark>.</p>

      <h3>Nous contacter</h3>
      <p>
        Courriel : <a href="mailto:contact@kokpit.io">contact@kokpit.io</a><br />
        Téléphone : <mark>[NUMÉRO DE TÉLÉPHONE À PUBLIER]</mark><br />
        Courrier : ADSPRING — Kokpit, 6, avenue de la Créativité, 59650 Villeneuve-d'Ascq
      </p>

      <h3>Hébergement</h3>
      <p>
        L'application est hébergée par Vercel Inc. (interface) et Railway Corp. (serveurs et base
        de données), dont les coordonnées complètes sont : <mark>[ADRESSE POSTALE ET TÉLÉPHONE DE
        CHAQUE HÉBERGEUR, À VÉRIFIER SUR LEURS SITES RESPECTIFS]</mark>.
      </p>
      <p>
        <mark>[SI VOUS UTILISEZ UN AUTRE HÉBERGEUR POUR LE SITE VITRINE OU LES SAUVEGARDES, L'AJOUTER
        ICI — la loi impose de nommer qui détient physiquement les données.]</mark>
      </p>

      <h2>1. Acceptation des conditions</h2>
      <p>
        En accédant à la plateforme Kokpit ou en l'utilisant, vous acceptez d'être lié par les présentes
        conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
      </p>

      <h2>2. Description du service</h2>
      <p>
        Kokpit est une plateforme de gestion et d'analyse de campagnes publicitaires digitales.
        Notre service permet de :
      </p>
      <ul>
        <li>Connecter et centraliser vos comptes publicitaires (Google Ads, Microsoft Ads, Meta Ads)</li>
        <li>Visualiser vos données analytics (Google Analytics, Matomo, Piano)</li>
        <li>Analyser vos performances grâce à l'intelligence artificielle</li>
        <li>Diagnostiquer automatiquement vos campagnes</li>
        <li>Collaborer avec votre équipe et vos clients</li>
      </ul>

      <h2>3. Inscription et compte</h2>
      <p>
        Pour utiliser Kokpit, vous devez créer un compte en fournissant des informations exactes et complètes.
        Vous êtes responsable de la confidentialité de vos identifiants de connexion et de toutes les activités
        effectuées sous votre compte.
      </p>

      <h2>4. Utilisation acceptable</h2>
      <p>Vous vous engagez à utiliser Kokpit de manière légale et responsable. Il est interdit de :</p>
      <ul>
        <li>Utiliser le service à des fins illégales ou non autorisées</li>
        <li>Tenter d'accéder à des données d'autres utilisateurs sans autorisation</li>
        <li>Perturber ou compromettre la sécurité du service</li>
        <li>Revendre ou redistribuer l'accès au service sans autorisation</li>
        <li>Utiliser des robots ou scripts automatisés pour accéder au service</li>
      </ul>

      <h2>5. Propriété intellectuelle</h2>
      <p>
        Kokpit et tous ses contenus (logiciels, interfaces, logos, textes) sont protégés par les droits
        de propriété intellectuelle. Vous conservez la propriété de vos données, mais nous accordez une
        licence limitée pour les traiter dans le cadre du service.
      </p>

      <h2>6. Abonnements et paiements</h2>
      <p>
        Certaines fonctionnalités de Kokpit nécessitent un abonnement payant. Le vendeur est
        <strong> ADSPRING</strong>, dont les coordonnées figurent aux mentions légales ci-dessus ;
        c'est à ce titre qu'elle émet les factures. Les tarifs en vigueur sont indiqués sur le
        site et s'entendent <mark>[HORS TAXES / TOUTES TAXES COMPRISES — à trancher]</mark>, la TVA applicable
        étant celle du taux français en vigueur.
      </p>
      <p>
        Les paiements sont traités par Stripe Payments Europe Ltd., qui en assure la sécurité ;
        aucune donnée de carte bancaire n'est conservée par l'éditeur. Les abonnements sont
        renouvelés automatiquement à échéance, sauf résiliation préalable depuis votre compte.
      </p>
      <p>
        <mark>[DROIT DE RÉTRACTATION — à rédiger : un abonnement souscrit par un professionnel n'y
        ouvre pas droit, un consommateur si, sauf renoncement exprès pour un service exécuté
        immédiatement. Précisez à qui vous vendez avant de formuler cette clause.]</mark>
      </p>
      <p>
        <mark>[DÉFAUT DE PAIEMENT — à rédiger : délai de régularisation, suspension du service,
        pénalités de retard et indemnité forfaitaire de recouvrement de 40 € dues entre
        professionnels.]</mark>
      </p>

      <h2>7. Résiliation</h2>
      <p>
        Vous pouvez résilier votre compte à tout moment depuis les paramètres de votre compte.
        Nous nous réservons le droit de suspendre ou de résilier votre accès en cas de violation
        des présentes conditions.
      </p>

      <h2>8. Limitation de responsabilité</h2>
      <p>
        Kokpit est fourni "tel quel". Nous ne garantissons pas que le service sera ininterrompu ou
        exempt d'erreurs. Notre responsabilité est limitée au montant que vous avez payé pour le
        service au cours des 12 derniers mois.
      </p>

      <h2>9. Modifications des conditions</h2>
      <p>
        Nous pouvons modifier ces conditions à tout moment. Les modifications importantes vous seront
        notifiées par email ou via l'application. Votre utilisation continue du service après ces
        modifications vaut acceptation.
      </p>

      <h2>10. Droit applicable</h2>
      <p>
        Les présentes conditions sont régies par le droit français. Tout litige sera soumis à la
        compétence exclusive des tribunaux français.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question concernant ces conditions d'utilisation, vous pouvez nous contacter à :
        <a href="mailto:contact@kokpit.io"> contact@kokpit.io</a>
      </p>
    </>
  );

  const privacyContent = (
    <>
      <p className="legal-page-updated">Dernière mise à jour : 4 juin 2025</p>

      <p>
        Chez Kokpit, nous accordons une importance primordiale à la protection de vos données personnelles.
        Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données est Adspring SAS, dont le siège social est situé en France.
        Pour toute question relative à la protection de vos données, vous pouvez nous contacter à :
        <a href="mailto:contact@kokpit.io"> contact@kokpit.io</a>
      </p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons les catégories de données suivantes :</p>

      <h3>Données d'identification</h3>
      <ul>
        <li>Nom et prénom</li>
        <li>Adresse email</li>
        <li>Mot de passe (hashé via bcrypt)</li>
      </ul>

      <h3>Données de connexion aux plateformes tierces</h3>
      <ul>
        <li>Tokens d'accès OAuth (Google Ads, Microsoft Ads, Meta Ads)</li>
        <li>Identifiants de comptes analytics (Google Analytics, Matomo, Piano)</li>
      </ul>

      <h3>Données d'utilisation</h3>
      <ul>
        <li>Logs de connexion</li>
        <li>Actions effectuées dans l'application</li>
        <li>Préférences utilisateur</li>
      </ul>

      <h3>Données publicitaires et analytics</h3>
      <ul>
        <li>Métriques de performance de vos campagnes</li>
        <li>Données de trafic et d'audience</li>
        <li>Rapports et analyses générés</li>
      </ul>

      <h2>3. Finalités du traitement</h2>
      <p>Vos données sont traitées pour les finalités suivantes :</p>
      <table className="legal-page-table">
        <thead>
          <tr>
            <th>Finalité</th>
            <th>Base légale</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fourniture du service Kokpit</td>
            <td>Exécution du contrat</td>
          </tr>
          <tr>
            <td>Gestion de votre compte</td>
            <td>Exécution du contrat</td>
          </tr>
          <tr>
            <td>Analyse et amélioration du service</td>
            <td>Intérêt légitime</td>
          </tr>
          <tr>
            <td>Communication sur les mises à jour</td>
            <td>Intérêt légitime</td>
          </tr>
          <tr>
            <td>Facturation</td>
            <td>Obligation légale</td>
          </tr>
          <tr>
            <td>Support client</td>
            <td>Exécution du contrat</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Partage des données</h2>
      <p>Vos données peuvent être partagées avec :</p>
      <ul>
        <li><strong>Sous-traitants techniques</strong> : hébergement (Railway, Vercel), paiements (Stripe)</li>
        <li><strong>Services d'IA</strong> : Anthropic (Claude), Google (Gemini) pour l'analyse de vos campagnes</li>
        <li><strong>Membres de votre organisation</strong> : selon les permissions configurées</li>
      </ul>
      <p>
        Nous ne vendons jamais vos données personnelles à des tiers. Les données transmises aux services
        d'IA sont utilisées uniquement pour générer des analyses et ne sont pas conservées par ces services
        au-delà du traitement.
      </p>

      <h2>5. Transferts internationaux</h2>
      <p>
        Certains de nos sous-traitants sont situés aux États-Unis. Ces transferts sont encadrés par
        des clauses contractuelles types approuvées par la Commission européenne ou par le Data Privacy
        Framework UE-US.
      </p>

      <h2>6. Conservation des données</h2>
      <p>Vos données sont conservées selon les durées suivantes :</p>
      <ul>
        <li><strong>Données de compte</strong> : durée de l'abonnement + 3 ans</li>
        <li><strong>Données publicitaires</strong> : 2 ans glissants</li>
        <li><strong>Logs de connexion</strong> : 1 an</li>
        <li><strong>Analyses IA</strong> : 1 an</li>
        <li><strong>Données de facturation</strong> : 10 ans (obligation légale)</li>
      </ul>

      <h2>7. Sécurité des données</h2>
      <p>Nous mettons en œuvre des mesures de sécurité appropriées :</p>
      <ul>
        <li>Hashage des mots de passe (bcrypt)</li>
        <li>Connexions HTTPS sécurisées</li>
        <li>Base de données avec connexion SSL</li>
        <li>Authentification JWT</li>
        <li>Hébergement sur des infrastructures sécurisées (Railway, Vercel)</li>
        <li>Accès restreint aux données selon les rôles</li>
      </ul>

      <h2>8. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
        <li><strong>Droit de rectification</strong> : corriger vos données inexactes</li>
        <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
        <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
        <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
        <li><strong>Droit à la limitation</strong> : limiter le traitement de vos données</li>
      </ul>
      <p>
        Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@kokpit.io">contact@kokpit.io</a>
      </p>
      <p>
        Vous pouvez également introduire une réclamation auprès de la CNIL :
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>
      </p>

      <h2>9. Cookies</h2>
      <p>
        Kokpit utilise des cookies essentiels au fonctionnement du service (authentification, préférences).
        Nous n'utilisons pas de cookies publicitaires ou de tracking tiers. Les cookies de session sont
        supprimés à la fermeture du navigateur.
      </p>

      <h2>10. Modifications de la politique</h2>
      <p>
        Nous pouvons mettre à jour cette politique de confidentialité. Les modifications importantes
        vous seront notifiées par email. Nous vous encourageons à consulter régulièrement cette page.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question concernant cette politique de confidentialité ou vos données personnelles :
      </p>
      <ul>
        <li>Email : <a href="mailto:contact@kokpit.io">contact@kokpit.io</a></li>
        <li>Support : <a href="mailto:contact@kokpit.io">contact@kokpit.io</a></li>
      </ul>
    </>
  );

  return (
    <div className="legal-page">
      <div className="legal-page-container">
        <div className="legal-page-header">
          <img src="/kokpit-logo-white.png" alt="Kokpit" className="legal-page-logo" />
          <h1>{title}</h1>
        </div>
        <div className="legal-page-content">
          {isTerms ? termsContent : privacyContent}
        </div>
        <div className="legal-page-footer">
          <a href="/">Retour à Kokpit</a>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
